import React, { PureComponent } from "react";
import QueryString from "query-string";
import DocumentTitle from "react-document-title";

import { BFF_BASE_URL } from "../../../../constants";
import { Redirect } from "../../../common/components";

class AuthRedirect extends PureComponent {
  render() {
    const { action } = this.props.match.params;
    let { state } = QueryString.parse(this.props.location.search);
    let decodedState = {};

    if (state === undefined) {
      decodedState = { action };
    } else {
      decodedState = window.atob(state);
      decodedState = JSON.parse(decodedState);
      decodedState = { ...decodedState, action };
    }

    state = window.btoa(JSON.stringify(decodedState));

    // eslint-disable-next-line object-shorthand
    const queryParameters = QueryString.stringify({ action, state });
    const source = `${BFF_BASE_URL}/b2c_url?${queryParameters}`;
    const titles = {
      signup: "WE | Sign Up",
      signin: "WE | Sign In",
      "forgot-password": "WE | Forgot Password",
    };

    return (
      <DocumentTitle title={titles[action]}>
        <Redirect source={source} />
      </DocumentTitle>
    );
  }
}

export default AuthRedirect;
